'use client';

import React, { ReactNode } from 'react';

interface DiagonalSectionProps {
  className?: string;
  children?: ReactNode;
  background?: string;
  angle?: string; // e.g., "10deg"
  direction?: 'left' | 'right';
  rotate?: string; // e.g., "2deg"
}

const DiagonalSection = ({
  className = '',
  children,
  angle = '10deg',
  background = 'linear-gradient(-45deg, #121212 0%, #3A41C6 15%, #3D3BBB 30%, #4634A7 45%, #4C2C96 60%, #512888 75%, #121212 100%)',
  direction = 'right',
  rotate
}: DiagonalSectionProps) => {
  const skewDirection = direction === 'right' ? '' : '-';
  const hasRotation = !!rotate;

  return (
    <div className={`relative w-full ${className}`}>
      <div
        className="absolute -top-48 left-0 right-0 bottom-0 -z-10 animate-diagonalGradient"
        aria-hidden="true"
        style={{
          background,
          transform: hasRotation ? `rotate(${rotate}) scaleX(2)` : `skewY(${skewDirection}${angle})`,
          transformOrigin: 'center',
          width: '200%',
          left: '-50%'
        }}
      />
      <div className="relative z-10 h-full flex items-center justify-center text-center text-white">
        {children}
      </div>
    </div>
  );
};

export default DiagonalSection;
